import { render, staticRenderFns } from "./auth-sms.vue?vue&type=template&id=6ccf7456&"
import script from "./auth-sms.vue?vue&type=script&lang=js&"
export * from "./auth-sms.vue?vue&type=script&lang=js&"
import style0 from "./auth-sms.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports